import { createContext } from 'react';

const pacienteContext = createContext();

export default pacienteContext;
